import "@hibas123/theme/out/base.css";
//@ts-ignore
import grid from "bundle-text:@hibas123/theme/out/grid.css";

document.head.appendChild(document.createElement("style")).innerHTML = grid;

//@ts-ignore
import light from "bundle-text:@hibas123/theme/out/light.css";
//@ts-ignore
import dark from "bundle-text:@hibas123/theme/out/dark.css";

// const light = fetch("./node_modules/@hibas123/theme/out/light.css", "utf8")
// const dark = readFileSync("./node_modules/@hibas123/theme/out/dark.css", "utf8")

import { Observable } from "@hibas123/utils";

export enum ThemeStates {
   AUTO,
   LIGHT,
   DARK
}

let themeConfig: ThemeStates = Number(localStorage.getItem("theme"));
if (Number.isNaN(themeConfig))
   themeConfig = ThemeStates.AUTO;

let isDark = false;
let mediaIsDark = false;

if (window.matchMedia) {
   const mediaq = matchMedia("(prefers-color-scheme: dark)");
   mediaIsDark = mediaq.matches;
   mediaq.onchange = ev => {
      mediaIsDark = ev.matches;
      apply();
   }
}

const isDarkObs = new Observable<boolean>();

let styleElm: HTMLStyleElement;
function apply(force?: boolean) {
   let shouldDark = themeConfig === ThemeStates.AUTO ? mediaIsDark : themeConfig === ThemeStates.DARK;
   if (force || shouldDark !== isDark) {
      if (styleElm) styleElm.remove();
      styleElm = document.createElement("style") as any as HTMLStyleElement;
      document.head.appendChild(styleElm);
      styleElm.innerHTML = shouldDark ? dark : light;
      isDark = shouldDark;
      isDarkObs.send(isDark)
   }
}
apply(true);

function change(state: ThemeStates, save: boolean) {
   themeConfig = state;
   if (save)
      localStorage.setItem("theme", String(themeConfig));
   apply();
}

export default {
   active: () => themeConfig,
   change: (state: ThemeStates, save = true) => change(state, save),
   isDark: () => isDark,
   isDarkObservable: isDarkObs.getPublicApi()
}